import React from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '@components'
import { InputGroup } from '@components/Inputs/InputGroup.tsx'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { IPaymentDetails } from '@query'
import styled from 'styled-components'

interface ReceiverSectionProps {
  register: UseFormRegister<IPaymentDetails>
  errors: FieldErrors<IPaymentDetails>
}

export const ReceiverSection: React.FC<ReceiverSectionProps> = ({ register, errors }) => {
  const { t } = useTranslation()

  return (
    <Container>
      <Input
        label={t('containers.paymentFormModal.receiverName')}
        required
        errors={errors.creditor?.name}
        {...register('creditor.name', {
          required: { value: true, message: t('validation.required') }
        })}
      />

      <InputGroup $sizes={[3, 2]}>
        <Input
          label={t('containers.paymentFormModal.iban')}
          required
          errors={errors.creditor?.iban}
          {...register('creditor.iban', {
            required: { value: true, message: t('validation.required') }
          })}
        />

        <Input
          label={t('containers.paymentFormModal.bic')}
          required
          errors={errors.creditor?.bic}
          {...register('creditor.bic', {
            required: { value: true, message: t('validation.required') }
          })}
        />
      </InputGroup>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`
